import classNames from 'classnames';
import { ForwardedRef, forwardRef, HTMLProps, ReactElement } from 'react';
import { Card, CardProps } from 'yoso';
import './BaseCard.scss';

export type BaseCardProps<T = HTMLProps<HTMLDivElement>> = CardProps<T> & {
  color?: CardProps['color'] | 'yellow' | 'orange' | 'blue' | 'green' | null;
  className?: string;
  shadow?: boolean;
};
const Component = function <T>(
  { shadow, className, color = 'default', ...props }: BaseCardProps<T>,
  ref: ForwardedRef<HTMLDivElement>
) {
  return (
    <Card
      className={classNames('base-card', { 'card-shadow': shadow }, className)}
      color={color as CardProps['color']}
      {...props}
      ref={ref}
    />
  );
};

export const BaseCard = forwardRef(Component) as <T = HTMLProps<HTMLDivElement>>(
  props: BaseCardProps<T>
) => ReactElement;
